import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import Loading from 'components/loading/Loading';
import { Row, Col, Card, Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';

import { aggiornaCurrentCliente } from 'features/global/globalSlice';
import ExcelExport from 'components/export/ExcelExport';
import { richiediDati, getFile } from './funzioni';

const Documenti = (props) => {
  const { caricamentoInCorso, documenti, clienti } = useSelector((s) => s.documenti98);
  const { currentCliente } = useSelector((s) => s.global);

  const dispatch = useDispatch();

  useEffect(() => {
    richiediDati();
  }, []);

  useEffect(() => {
    if (clienti.indexOf(currentCliente) === -1) {
      dispatch(aggiornaCurrentCliente(clienti[0]));
    }
  }, [clienti]);
  if (caricamentoInCorso) return <Loading />;

  return (
    <>
      <Row>
        <Col>
          <section className="scroll-section d-flex justify-content-between w-100">
            <h1>Documents</h1>
            <ExcelExport idTabella="tabella-documenti98" />
          </section>

          {/* eslint-disable-next-line */}
          <select onChange={(e) => dispatch(aggiornaCurrentCliente(e.target.value))} value={currentCliente} className="form-select my-3">
            {clienti.map((cliente) => (
              <option key={cliente} value={cliente}>
                {cliente}
              </option>
            ))}
          </select>
          <section className="scroll-section">
            <Card body>
              <BootstrapTable
                id="tabella-documenti98"
                striped
                bootstrap4
                condensed
                wrapperClasses="table-responsive"
                keyField="Doc"
                data={documenti[currentCliente] ?? []}
                columns={[
                  {
                    dataField: 'Anno',
                    text: 'Year',
                  },
                  {
                    dataField: 'DataDoc',
                    text: 'Date',
                  },
                  {
                    dataField: 'Totale',
                    text: 'Total',
                    formatter: (cell, row) =>
                      `${row?.Valuta} ${cell
                        ?.toFixed(2)
                        .toString()
                        .split(/(?=(?:\d{3})+(?:\.|$))/g)
                        .join(',')}`,
                  },
                  {
                    dataField: 'Doc',
                    text: 'Document',
                  },
                  {
                    dataField: '',
                    text: 'Actions',
                    formatter: (cell, row) => (
                      <>
                        <Button onClick={() => getFile(row?.Doc, row?.Anno)}>Download</Button>
                      </>
                    ),
                  },
                ]}
              />
            </Card>
          </section>
        </Col>
      </Row>
    </>
  );
};

export default Documenti;
